var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-image',{staticClass:"CoverImage",style:(_vm.styles),attrs:{"src":_vm.innerSrc,"fit":_vm.fit},on:{"click":_vm.handleClick,"load":_vm.handleLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }